import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import PanelSubHeading from "../../components/panel/subHeading";
import PanelHeading from "../../components/panel/heading";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import UserListTable from "../../components/users/userListTable";
import { useDispatch, useSelector } from "react-redux";
import { actions, RootState } from "../../state/reducer";
import { closeModal, openModal } from "../../state/modalSlice";
import LinksListTable from "../../components/users/inviteLinksTable";
import CreateInviteLinkModal from "../../modals/users/createLink";

const InviteListPage = () => {

  const [searchValue, setSearchValue] = useState("")
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const search = (value: string) => {
    setSearchValue(value);
  }

  const handleOpenCreate = () => {
    dispatch(openModal({ component: CreateInviteLinkModal, context: {
      onApplyFilters: () => {
        setSearchValue("");
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  }

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="profileWidget">
          <div className="flex between">
            <PanelSubHeading text="Приглашения" />
            <div className="panelBtnContainer">
            <div className="btn panelActionBtn" onClick={handleOpenCreate}>+ Создать ссылку</div>
            </div>
          </div>
          <div className="flex between panelSearchContainer">
             <PanelSearch hint={"Поиск по ФИО"} onChange={search} />
          </div>
          <LinksListTable search={searchValue} />
        </div>
      </div>
    </PanelPage>
  );
};

export default InviteListPage;
